module.exports = __webpack_public_path__ + "1bc2910.woff2";